<template>
  <q-page
    class="full-height"
  >
    <div
      class="content-container
    max-width
    column
    justify-center
    items-center
    text-headline
    text-primary"
    >
      <div class="header-text text-center">
        {{ $t('locations.welcome') }}
      </div>
      <div class="header-text-2">
        {{ $t('locations.select') }}
      </div>
      <div
        class="q-gutter-lg"
        :class="{
          'row' : $q.screen.width > 600,
          'column items-center q-mt-md' : $q.screen.width <= 600,
        }"
      >
        <div class="btn-container">
          <div class="row full-height justify-center items-center">
            <q-img
              :src="$q.screen.width > 600 ? 'logo-rvk-white.svg' : 'logo-rvk.svg'"
              class="cursor-pointer logo"
              @click="onClickLocation(rvkLocationId)"
            />
          </div>
        </div>
        <div class="btn-container row justify-center items-center">
          <q-img
            :src="$q.screen.width > 600 ? 'logo-ak-white.svg' : 'logo.svg'"
            class="cursor-pointer logo"
            @click="onClickLocation(akLocationId)"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>
<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import LocationModel from 'quasar-pilot-core/src/lib/models/location';

export default defineComponent({
  data() {
    return {
      akLocationId: 2,
      rvkLocationId: 1,
    };
  },

  computed: {
    ...mapState('location', { currentLocation: 'current' }),
    ...mapGetters('location', ['findLocation']),
  },

  methods: {
    ...mapMutations('location', ['updateCurrentLocation']),
    ...mapMutations('application', [
      'updateDefaultDeliveryMethod',
    ]),

    async onClickLocation(locationId) {
      const location = new LocationModel(this.findLocation(locationId));
      await this.updateCurrentLocation(location);
      if (location.deliveryMethods && location.deliveryMethods.length > 0) {
        await this.updateDefaultDeliveryMethod({ deliveryMethod: location.deliveryMethods[0] });
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.q-page {
  background-image: url('/images/bg1.png');
  background-position: center;
  background-size: cover;
  @media (max-width: 600px) {
    background-image: url('/images/mobile-bg.svg');
    background-color: $primary;
    background-size: cover;
  }
  .content-container {
    height: 95vh;
    .header-text {
      font-size: 64px;
      font-weight: 800;
      @media (max-width: 600px) {
        font-size: 26px;
        color: white;
      }
    }
    .header-text-2 {
      font-size: 32px;
      font-weight: 600;
      @media (max-width: 600px) {
        font-size: 16px;
        color: white;
      }
    }
    .btn-container {
      background-image: url('/images/location-bg.svg');
      background-repeat: no-repeat;
      background-size: cover;
      height: 370px;
      width: 400px;
      @media (max-width: 991px) {
        height:260px;
        width: 280px;
      }
      @media (max-width: 600px) {
        background-image: url('/images/location-bg-white.svg');
        height:213px;
        width: 229px;
      }
    }
    .logo {
      height: 100px;
      width: 225px;
      @media (max-width: 992px) {
        height: 70px;
        width:158px;
      }
      transition: all 0.3s ease;
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}
</style>
